// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loggedout-navbar {
  padding: 0.5rem 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 100;
  background-color: var(--background);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.loggedout-navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  padding: 0 1rem;
}

.loggedout-navbar-nav {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.loggedout-nav-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: var(--text-primary);
  padding: 0.5rem;
  transition: all 0.3s ease;
}

.loggedout-nav-link span {
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

.loggedout-nav-link:hover {
  color: var(--theme-consistent);
}

.loggedout-nav-link.active {
  color: var(--theme-consistent);
}

.loggedout-nav-link.active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: var(--theme-consistent);
}

.loggedout-nav-link.signup {
  background-color: transparent;
  color: var(--theme-consistent);
  border: 2px solid var(--theme-consistent);
  border-radius: 20px;
  padding: 0.5rem 1rem;
}

.loggedout-nav-link.signup:hover {
  background-color: var(--theme-consistent);
  color: white;
}

.loggedout-nav-link.signup.active {
  background-color: var(--theme-consistent);
  color: white;
}

@media (min-width: 768px) {
  .loggedout-navbar {
    top: 0;
    bottom: auto;
    background-color: transparent;
    box-shadow: none;
  }

  .loggedout-navbar-nav {
    justify-content: flex-end;
    gap: 2rem;
  }

  .loggedout-nav-link {
    flex-direction: row;
  }

  .loggedout-nav-link span {
    font-size: 1rem;
    margin-left: 0.5rem;
    margin-top: 0;
  }

  .loggedout-nav-link.signup {
    padding: 0.5rem 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/LoggedOutNavbar.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;EACzC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE;IACE,MAAM;IACN,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".loggedout-navbar {\n  padding: 0.5rem 0;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  z-index: 100;\n  background-color: var(--background);\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.loggedout-navbar-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 0 1rem;\n}\n\n.loggedout-navbar-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.loggedout-nav-link {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-decoration: none;\n  color: var(--text-primary);\n  padding: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.loggedout-nav-link span {\n  font-size: 0.8rem;\n  margin-top: 0.25rem;\n}\n\n.loggedout-nav-link:hover {\n  color: var(--theme-consistent);\n}\n\n.loggedout-nav-link.active {\n  color: var(--theme-consistent);\n}\n\n.loggedout-nav-link.active::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background-color: var(--theme-consistent);\n}\n\n.loggedout-nav-link.signup {\n  background-color: transparent;\n  color: var(--theme-consistent);\n  border: 2px solid var(--theme-consistent);\n  border-radius: 20px;\n  padding: 0.5rem 1rem;\n}\n\n.loggedout-nav-link.signup:hover {\n  background-color: var(--theme-consistent);\n  color: white;\n}\n\n.loggedout-nav-link.signup.active {\n  background-color: var(--theme-consistent);\n  color: white;\n}\n\n@media (min-width: 768px) {\n  .loggedout-navbar {\n    top: 0;\n    bottom: auto;\n    background-color: transparent;\n    box-shadow: none;\n  }\n\n  .loggedout-navbar-nav {\n    justify-content: flex-end;\n    gap: 2rem;\n  }\n\n  .loggedout-nav-link {\n    flex-direction: row;\n  }\n\n  .loggedout-nav-link span {\n    font-size: 1rem;\n    margin-left: 0.5rem;\n    margin-top: 0;\n  }\n\n  .loggedout-nav-link.signup {\n    padding: 0.5rem 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
